export const getCurrentAcademicYearStartYear = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return month >= 8 ? year : year - 1;
};

export const formatAcademicYear = (startYear) => {
    const endYear = (startYear + 1).toString().slice(-2);
    return `${startYear}/${endYear}`;
};

export const getCurrentAcademicYear = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed: Jan=0, Feb=1, ..., Sep=8, ..., Dec=11
    
    let academicStartYear;
    let period;
    
    if (month >= 1 && month <= 7) {
        // February (1) to August (7): Period 1 of current academic year
        academicStartYear = getCurrentAcademicYearStartYear(date);
        period = 1;
    } else {
        // September (8) to January (0): Period 2 of current academic year
        academicStartYear = getCurrentAcademicYearStartYear(date);
        period = 2;
    }
    
    const endYearShort = (academicStartYear + 1).toString().slice(-2);
    return `${academicStartYear}/${endYearShort}-${period}`;
};

export const getPreviousAcademicYear = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed: Jan=0, Feb=1, ..., Sep=8, ..., Dec=11
    
    let academicStartYear;
    let period;
    
    if (month >= 1 && month <= 7) {
        // February (1) to August (7): Period 1 of current academic year
        academicStartYear = year - 1;
        period = 1;
    } else {
        // September (8) to January (0): Period 2 of previous academic year
        if (month >= 8) {
            // September to December
            academicStartYear = year - 1;
        } else {
            // January
            academicStartYear = year - 2;
        }
        period = 2;
    }
    
    const endYearShort = (academicStartYear + 1).toString().slice(-2);
    return `${academicStartYear}/${endYearShort}-${period}`;
};